/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2025-09-19 19:30:28
 */
import '../index.scss'
import React, { useState } from 'react'

// 照片类型
interface Photo {
  photoUrl: string
  photoTime?: string
  photoAddress?: string
}

interface VerifyResultPhotoProps {
  photo: Photo
  status: string
}

export default ({ photo, status }: VerifyResultPhotoProps) => {
  const [showCheckbox, setShowCheckbox] = useState(false)

  return (
    <>
      <div
        className="photo"
        onMouseEnter={() => setShowCheckbox(true)}
        onMouseLeave={() => setShowCheckbox(false)}
      >
        <div className="photo-box">
          <img
            src={photo.photoUrl + '?x-oss-process=image/resize,w_400'}
            alt=""
          />
          {showCheckbox && <div className="tip">点击查看验真报告</div>}
        </div>
      </div>
      {status !== 'unKnow' && <div className="time">{photo.photoTime}</div>}
      {status !== 'unKnow' && (
        <div className="address">{photo.photoAddress}</div>
      )}
    </>
  )
}
